export const SIMILAR_JOBS_LIMIT = 9;
export const SIDEBAR_SIMILAR_JOBS_LIMIT = SIMILAR_JOBS_LIMIT + 4;

export { JobDetails } from './job-details';
